import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Config from '../config'

function injectPendoSnippet(apiKey) {
  if (window.pendo || document.querySelector('script[data-pendo-key]')) return

  ;(function(p, e, n, d, o) {
    var v, w, x, y, z
    o = p[d] = p[d] || {}
    o._q = o._q || []
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track', 'trackAgent']
    for (w = 0, x = v.length; w < x; ++w) {
      ;(function(m) {
        o[m] =
          o[m] ||
          function() {
            o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)))
          }
      })(v[w])
    }
    y = e.createElement(n)
    y.async = true
    y.setAttribute('data-pendo-key', apiKey)
    y.src = 'https://cdn.eu.pendo.io/agent/static/' + apiKey + '/pendo.js'
    z = e.getElementsByTagName(n)[0]
    z.parentNode.insertBefore(y, z)
  })(window, document, 'script', 'pendo')
}

function PendoInitializer() {
  const { i18n } = useTranslation()
  const ssoUser = useSelector(state => state.auth.ssoUser)
  const profile = useSelector(state => state.auth.profile)

  useEffect(() => {
    if (!Config.pendo.enabled || !Config.pendo.apiKey || !ssoUser || !profile) return

    injectPendoSnippet(Config.pendo.apiKey)

    const community = profile.current_community
    const language = i18n.language?.toLowerCase().substring(0, 2) || 'en'

    window.pendo.initialize({
      visitor: {
        id: profile.email,
        email: profile.email,
        firstName: profile.first_name,
        lastName: profile.last_name,
        language,
        user_id: profile.id,
        role: profile.role,
        userPermissions: profile.user_permissions,
        ...(profile.product_fruits_custom_props || {}),
        ...(profile.pendo_custom_props || {}),
      },
      account: {
        id: profile?.product_fruits_custom_props?.current_community_zid ?? null,
        account_name: community?.name ?? null,
        environment: Config.env,
        plan_name: community?.tiering_plan_name ?? null,
        non_paying_client: community?.temp_non_paying_client ?? null,
        new_comms_experience: community?.new_comms_experience ?? null,
      },
    })
  }, [ssoUser, profile])

  return null
}

export default PendoInitializer
